<template>
  <div class="errors-intelligence-content-block-item">
    <pre-loader :value="ajaxLoading" opacity />
    <div class="errors-intelligence-content-block-text" v-if="!edit">
      <span>{{ errorItem[field] }}</span>

      <button
        v-if="checkRole"
        @click="edit = !edit"
        class="btn btn-onlytext btn-change-correction"
      >
        <svg class="icon">
          <use xlink:href="/img/icons/icons-sprite.svg#edit" />
        </svg>
      </button>
    </div>

    <div v-if="edit" class="errors-intelligence-content-block-form">
      <textarea v-model="errorItem[field]"></textarea>

      <div class="errors-intelligence-content-block-form-buttons">
        <button @click="saveField" class="btn btn-blue">Save</button>

        <span class="delimiter">or</span>

        <button @click="cancelSave" class="btn btn-onlytext">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';
import { ROLE_SYSTEM_ADMIN, ROLE_QA_EXPERT, ROLE_PROOF_READER } from '@/utils/const';

export default Vue.extend({
  components: {
    'pre-loader': () => import('@/components/preloader/index.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
  },
  computed: {
    checkRole() {
      if (this.$store.getters.userRole === ROLE_SYSTEM_ADMIN ||
          this.$store.getters.userRole === ROLE_QA_EXPERT ||
          this.$store.getters.userRole === ROLE_PROOF_READER) {
        return true;
      }
      return false;
    },
  },
  methods: {
    saveField() {
      this.ajaxLoading = true;
      Api.reports.correctionUpdate(this.errorItem)
        .then((data) => {
          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'Update successful',
              type: 'info',
              show: true,
            });
            this.$emit('input', this.errorItem);
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        }).finally(() => {
          this.ajaxLoading = false;
          this.edit = false;
        });
    },
    cancelSave() {
      this.edit = false;
      this.errorItem = { ...this.value };
    },
  },
  data: () => ({
    edit: false,
    errorItem: Object(),
    ajaxLoading: false,
  }),
  mounted() {
    this.errorItem = { ...this.value };
  },
});
</script>

<style lang="scss">
  .errors-intelligence-content-block-item {
    position: relative;
  }
</style>
